import ajax from './axios'

export const getfilter = (params) => {
    return ajax.get('/api/v2/hotkeyword/filter?year=' + params.year + '&category_type=' + params.type, )
}

export const getchart = (params) => {
    return ajax.get('/api/v2/hotkeyword/chart?year=' + params.year + '&category=' + params.category + '&keyword=' + params.keyword + '&venue_type=' + params.type)
}

export const getGeoFilter = (params) => {
    return ajax.get('/api/v2/hotkeyword/geoscience/filter?year=' + params.year)
}


// WEBPACK FOOTER //
// ./src/api/hotkeyword.js